import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@mui/material';
import SideBar from '../SideBar';

class LegacyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(
      'REACT_ERROR',
      error,
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      info.componentStack
    );
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

function FallbackComponent({ error, orgId }) {
  return (
    <>
      {!orgId && <SideBar safeMode />}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: 'calc(100vh - 76px)',
        }}
      >
        <h2>Oops, something went wrong. Please try again.</h2>
        <Button onClick={() => window.location.reload()}>Refresh</Button>
      </Box>
    </>
  );
}

function ErrorBoundary({ children, orgId }) {
  return (
    <LegacyErrorBoundary fallback={() => <FallbackComponent orgId={orgId} />}>
      {children}
    </LegacyErrorBoundary>
  );
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  orgId: PropTypes.string,
};

export default ErrorBoundary;
